import '../../title.css';

const React = require('react');
const ModalWindow = require('../../../../core/modal').default;
const assets = require('../../../../assets').default;
const { applicationStyle } = require('../../../app.style').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

const tipsStyle = {
    width: (applicationStyle.width * 0.95)
}

export default class tipsComponent extends React.Component {
    renderContents() {
        return (
            <div style={tipsStyle}>
                <div className="tips-layout">
                    <div className="tips-message">
                        <div className="tips-text">
                            <div>王女メア:</div>
                            <div>冒険者様、深淵の古城に潜む魔女の討伐をお願いいたします。古城にいるモンスターは、冒険者様のスキルを使って、このポリンボックスで召喚したポリンを巻き込むことでダメージを与えることができます。</div>
                        </div>
                        <div className="tips-image-flex">
                            <img src={assets.ModalMea01} className="tips-image" />
                        </div>
                    </div>
                    <div className="tips-message">
                        <div className="tips-image-flex">
                            <img src={assets.IconPorinBox} className="tips-image" />
                        </div>
                        <div className="tips-text">
                            <div>同じ色のポリンは連鎖することで威力が倍になっていきます。うまく配置を利用してモンスターを倒し、最奥を目指してください！！</div>
                        </div>

                    </div>
                    <div className="tips-text"></div>
                    <div className="tips-image-flex">
                        <img className="tips-image" src={assets.TipsImage} />
                    </div>
                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable);
                            this.props.handleBackClick()
                        }}>戻る</div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            closeRequest={this.props.handleBackClick}
            isCloseOutOfArea={true}
            contents={this.renderContents()}
        />
    }
}